import { useLiveQuery } from 'dexie-react-hooks'
import { useClub } from '../club/ClubProvider.tsx'
import { mergeOverlay, type Pending } from './merge.ts'

/** Live, merged (server + pending local) rows of one mirrored table. `undefined` while the first read is in flight. */
export function useMerged<T extends { id: string }>(store: string, serverTable: string): Array<Pending<T>> | undefined {
  const { db } = useClub()
  return useLiveQuery(async () => {
    const [mirror, overlay] = await Promise.all([db.table(store).toArray(), db.overlay.where('table').equals(serverTable).toArray()])
    return mergeOverlay(mirror as T[], overlay)
  }, [db, store, serverTable])
}
